<template>
  <div :class="[getClassName, getLoadingClass, getPersonalizeLoadingClass]">
    <div class="matrix-vld-parent">
      <div class="matrix-vld-overlay">
        <div class="matrix-vld-background"></div>
        <div class="matrix_loading_circle"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { usePersonalizeStore } from "@/stores/modules/personalize";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(usePersonalizeStore, ["getPersonalizeLoading"]),
    getLoadingClass: function () {
      return this.initialLoading ? "matrix_loadingInitial" : "";
    },
    getPersonalizeLoadingClass: function () {
      return this.getPersonalizeLoading ? "matrix_loadingPersonalize" : "";
    }
  },
  props: ["initialLoading"],
  data() {
    return {
      isLoading: true,
      fullPage: false,
      height: 100,
      width: 100
    };
  }
};
</script>
